module.exports = __webpack_public_path__ + "static/media/feat-cumberland-img1.d99ed52e.jpg";